import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { Globals } from "../globals";
import { httpsCallable } from "firebase/functions";
import { functions } from "../services/firebase";
import Container from "react-bootstrap/esm/Container";
import Card from "react-bootstrap/esm/Card";
import Form from "react-bootstrap/esm/Form";
import Button from "react-bootstrap/esm/Button";
import Spinner from "react-bootstrap/esm/Spinner";
import Alert from "react-bootstrap/esm/Alert";
import AppFooter from "../footer/AppFooter";

/**
 * Public page /mein-plan: a preacher asks for their personal link by e-mail.
 * The answer is always the same, whether the address is known or not.
 */
export default function MyPlanRequest() {
    const { t } = useTranslation();
    const [email, setEmail] = useState("");
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");
    // The same form serves the conductor at /chor; only the wording differs.
    const forConductor = useLocation().pathname.startsWith(Globals.PATH_CHOIR_PLAN);

    useEffect(() => {
        document.title = t(forConductor ? "choirPlan.title" : "myPlan.title");
    }, [t, forConductor]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setSending(true);
        setError("");
        try {
            await httpsCallable<{ email: string }, { success: boolean }>(functions, "requestMyPlanLink")({ email: email.trim() });
            setSent(true);
        } catch (err: unknown) {
            const code = (err as { code?: string }).code;
            setError(t(code === "functions/invalid-argument" ? "myPlan.requestInvalidEmail" : "errors.anErrorOccurred") as string);
        } finally {
            setSending(false);
        }
    };

    return (
        <>
            <Container className="mt-4" style={{ maxWidth: "520px" }}>
                <Card>
                    <Card.Header>
                        <h4 className="mb-0">{t(forConductor ? "choirPlan.heading" : "myPlan.requestHeading")}</h4>
                    </Card.Header>
                    <Card.Body>
                        {sent ? (
                            <Alert variant="success" className="mb-0">
                                {t("myPlan.requestSent")}
                            </Alert>
                        ) : (
                            <Form onSubmit={handleSubmit}>
                                <p>{t(forConductor ? "choirPlan.requestIntro" : "myPlan.requestIntro")}</p>
                                <Form.Group className="mb-3" controlId="myPlanEmail">
                                    <Form.Label>{t("myPlan.requestEmail")}</Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="name@beispiel.de"
                                        autoComplete="email"
                                        required
                                    />
                                </Form.Group>
                                {error && <Alert variant="danger">{error}</Alert>}
                                <Button type="submit" disabled={sending || !email.trim()} className="w-100">
                                    {sending && <Spinner as="span" animation="border" size="sm" className="me-2" />}
                                    {t("myPlan.requestSubmit")}
                                </Button>
                            </Form>
                        )}
                    </Card.Body>
                </Card>
            </Container>
            <AppFooter />
        </>
    );
}
